export {
  ResponsiveIcon,
  ResponsiveColoredIcon,
} from "./SingleColorResponsive/SingleColorIconResponsive";
